import React from 'react'
import Moment from 'moment'

class Session extends React.Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.getClassName = this.getClassName.bind(this)
  }
  handleClick() {
    this.props.handleSessionClick(this.props.session)
  }
  getClassName() {
    let deact = ""
    let modifiedNow = null
    if (Moment().isDST()) {
      modifiedNow = Moment.utc().add(3, 'hour')
    } else {
      modifiedNow = Moment.utc().add(2, 'hour')
    }
    if (modifiedNow.diff(Moment.utc(this.props.session.ShowTime), "minutes") > 15) {
      deact = " deact"
    }
    return "session" + deact
  }
  render() {
    return (
      <div className={this.getClassName()} onClick={() => {this.handleClick()}}>
        {Moment.utc(this.props.session.ShowTime).format("HH:mm")}
        {this.props.session.attributes.length > 0 && <p className="attr">
          {this.props.session.attributes.map(attr => 
            attr.name !== "2D" && <span key={attr.name}>{attr.name}</span>
          )}
        </p>}
      </div>
    )
  }
}

export default Session


// WEBPACK FOOTER //
// ./src/components/snippets/Session.jsx